import { render, staticRenderFns } from "./MontagemCargaMdfe.vue?vue&type=template&id=4f05eecd"
import script from "./MontagemCargaMdfe.vue?vue&type=script&lang=js"
export * from "./MontagemCargaMdfe.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports